"use strict";
// copied from @vwa/components-configure
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EfficiencyClassArrowPath = exports.getBaselinePathWidth = exports.arrowPathHeight = exports.arrowTipWidth = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const React = __importStar(require("react"));
exports.arrowTipWidth = 8;
exports.arrowPathHeight = 20;
/**
 *  Result of: padding-left (8px) + padding-right (8px) + max efficiencyClass length * 8px ("A+" => 2 * 8px => 16px)
 */
const getBaselinePathWidth = (bestEfficiencyClass) => bestEfficiencyClass === 'A+++' ? 48 : 32;
exports.getBaselinePathWidth = getBaselinePathWidth;
// These colors are the best possible approximation color values to the print colors mandated by EU rules
const efficiencyClassColorValues = {
    darkGreen: { fillColor: '#009640', textColor: '#fff' },
    mediumGreen: { fillColor: '#51ae32', textColor: '#000' },
    lightGreen: { fillColor: '#c7d300', textColor: '#000' },
    yellow: { fillColor: '#ffe600', textColor: '#000' },
    lightOrange: { fillColor: '#fbb900', textColor: '#000' },
    darkOrange: { fillColor: '#ec6607', textColor: '#fff' },
    red: { fillColor: '#e30513', textColor: '#fff' }
};
const efficiencyClassColorMap = {
    'A+': efficiencyClassColorValues.darkGreen,
    A: efficiencyClassColorValues.darkGreen,
    B: efficiencyClassColorValues.mediumGreen,
    C: efficiencyClassColorValues.lightGreen,
    D: efficiencyClassColorValues.yellow,
    E: efficiencyClassColorValues.lightOrange,
    F: efficiencyClassColorValues.darkOrange,
    G: efficiencyClassColorValues.red
};
const efficiencyClassColorMapExtended = {
    'A+++': efficiencyClassColorValues.darkGreen,
    'A++': efficiencyClassColorValues.mediumGreen,
    'A+': efficiencyClassColorValues.lightGreen,
    A: efficiencyClassColorValues.yellow,
    B: efficiencyClassColorValues.lightOrange,
    C: efficiencyClassColorValues.darkOrange,
    D: efficiencyClassColorValues.red,
    E: efficiencyClassColorValues.red,
    F: efficiencyClassColorValues.red,
    G: efficiencyClassColorValues.red
};
const StyledSVGText = components_core_1.styled.text `
  fill: ${props => props.bestEfficiencyClass === 'A+++'
    ? efficiencyClassColorMapExtended[props.efficiencyClass].textColor
    : efficiencyClassColorMap[props.efficiencyClass].textColor};
  font-size: ${props => props.theme.fonts.label[150].fontSize};
  font-weight: bold;
`;
const EfficiencyClassArrowPath = ({ efficiencyClass, bestEfficiencyClass, width, yPosition = 0 }) => (React.createElement(React.Fragment, null,
    React.createElement("path", { fill: bestEfficiencyClass === 'A+++'
            ? efficiencyClassColorMapExtended[efficiencyClass].fillColor
            : efficiencyClassColorMap[efficiencyClass].fillColor, d: `M0 ${yPosition} h ${width} l ${exports.arrowTipWidth} ${exports.arrowPathHeight /
            2} l -${exports.arrowTipWidth} ${exports.arrowPathHeight / 2} H 0` }),
    React.createElement(StyledSVGText, { efficiencyClass: efficiencyClass, bestEfficiencyClass: bestEfficiencyClass, x: exports.arrowTipWidth, y: yPosition + exports.arrowPathHeight / 2, 
        // shift text along y-axis to the center of the path
        dy: ".35em", "aria-hidden": "true" }, efficiencyClass)));
exports.EfficiencyClassArrowPath = EfficiencyClassArrowPath;
exports.EfficiencyClassArrowPath.displayName = 'EfficiencyClassArrowPath';
